export default __webpack_public_path__ + "static/media/place.596d4984.png";